import gql from 'graphql-tag';

export const INSURANCE_QUERY = gql`
    query fetchInsurancePlan($planId: String) {
        insurancePlan(planId: $planId) {
            isNonGovernment
            isPremiumEligibleInsurance
        }
    }
`;
